import React from "react";

const ChildProductCategory = ({ items }) => {
  return (
    <>
      {items.map((item, index) => (
        <li className={`nav-item ${item.IsActive !== null && item.IsActive ? "active" : ""}`} key={index}>
          <a className="btn d-flex" rel="nofollow" href={item.Url}>
            {item.DisplayName}
          </a>
        </li>
      ))}
    </>
  );
};

export default ChildProductCategory;
